module.exports = __webpack_public_path__ + "assets/img/Sonance_011.0b3980fb.jpg";